import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Rocket, Loader2, Check, Clock, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const ICON = { done: <Check className="w-4 h-4 text-[#2D6A4F]" />, running: <Loader2 className="w-4 h-4 animate-spin text-[#C59B27]" />, failed: <X className="w-4 h-4 text-red-700" />, waiting: <Clock className="w-4 h-4 text-[#C59B27]" /> };

export const LaunchProduct = ({ guideId, path, what = "guide", tid = "", onChanged }) => {
  const url = path || `/guides/${guideId}/launch`;
  const [s, setS] = useState(null);
  const load = useCallback(() => api.get(url).then((r) => setS(r.data)).catch(() => {}), [url]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (s?.status !== "running") return undefined;
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [s?.status, load]);
  useEffect(() => { if (s?.status === "done") onChanged?.(); }, [s?.status]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!s) return null;
  const go = async () => {
    if (!window.confirm(`Launch this ${what}? It writes any missing sales shorts, drafts the Instagram post if there isn't one, publishes it to the shop feed, then checks it shows on theexpatstudio.com.`)) return;
    try { await api.post(url); toast.success("Launch started"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const running = s.status === "running";
  return (
    <section className="border border-[#E2D9CC] bg-[#FAF7F2] p-6 mt-10" data-testid={`launch-product${tid}`}>
      <div className="flex flex-wrap items-center gap-4">
        <div className="mr-auto">
          <p className="eyebrow mb-1 flex items-center gap-2"><Rocket className="w-4 h-4" strokeWidth={1.5} />Launch product</p>
          <p className="text-sm text-[#8C827A]">One click: sales shorts, Instagram post, publish, then a check that it's on theexpatstudio.com.</p>
        </div>
        <Button onClick={go} disabled={running} className="rounded-none" data-testid={`launch-product-button${tid}`}>
          {running ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Rocket className="w-4 h-4 mr-2" />}{running ? "Launching…" : s.status ? "Launch again" : "Launch"}
        </Button>
      </div>
      {s.status && <ol className={`mt-5 grid gap-3 ${tid ? "sm:grid-cols-2" : "sm:grid-cols-4"}`}>{s.steps.map((st) => (
        <li key={st.key} className="border border-[#E2D9CC] bg-white p-3 text-sm" data-testid={`launch-step-${st.key}${tid}`}>
          <div className="flex items-center gap-2 font-medium">{ICON[st.status] || <span className="w-4 h-4 rounded-full border border-[#C9BFB2]" />}{st.label}</div>
          {st.detail && <p className="text-xs text-[#8C827A] mt-1">{st.detail}</p>}
        </li>))}</ol>}
      {s.error && <p className="text-xs text-red-700 mt-3" data-testid={`launch-error${tid}`}>{s.error}</p>}
    </section>
  );
};
